import React, { ReactNode } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

/**
 * Modal.
 */
const Modal: React.FC<{
  children: ReactNode;
  title?: string;
  buttonText: string;
  large?: boolean;
  showTitle?: boolean;
}> = ({ children, title, buttonText, large = false, showTitle = true }) => (
  <Dialog.Root>
    <Dialog.Trigger asChild>
      <button type="button">{buttonText}</button>
    </Dialog.Trigger>
    <Dialog.Portal>
      <Dialog.Trigger asChild>
        <Dialog.Overlay className="dialog-overlay" />
      </Dialog.Trigger>
      <Dialog.Content
        className={`dialog-content-wrapper ${large ? 'wide' : ''}`}
        aria-describedby={undefined}
      >
        <Dialog.Close
          data-button-type="control"
          data-button-variation="outline"
          aria-label="Close"
          className="close font-size-md"
        >
          <i className="icon-close"></i>
        </Dialog.Close>
        <Dialog.Title
          className={`dialog-title ${showTitle ? '' : 'visually-hidden'}`}
        >
          {title}
        </Dialog.Title>
        <div className="dialog-content">{children}</div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
export default Modal;
